import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/filters';
import '@/scoring';
import chartjs from 'vue-chartjs';
import tooltip from 'v-tooltip';
Vue.use(tooltip);
import 'buefy/dist/buefy.css';

Vue.config.productionTip = false;
Vue.prototype.$watchlist = "This contracting state has been placed on watch by AWG due to ongoing material developments that may affect its score, the impact of which has not yet been assessed. Please read this scorecard and related materials with added caution.";

import Buefy from "buefy";

Vue.use(require('vue-moment'));

import vueCarousel from "vue-carousel";
Vue.use(vueCarousel);

import '@/assets/css/global.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@fortawesome/free-regular-svg-icons';
import '@fortawesome/pro-regular-svg-icons';
//import { faPaypal } from '@fortawesome/free-brands-svg-icons';
//library.add(faPaypal);
Vue.component('fa', FontAwesomeIcon);
import '@fortawesome/fontawesome-pro/css/all.css';
//import '@fortawesome/fontawesome-pro/js/all.js';

//import * as pdfjs from "pdfjs-dist";
//import * as pdfjs from "pdfjs-dist/legacy/build/pdf.mjs" //"pdfjs-dist/legacy/build/pdf.mjs";
//console.log("pdfjs test", pdfjs);
//Vue.prototype.$pdfjs = pdfjs;

Vue.use(Buefy, {
  defaultIconPack: "fa",
});
Vue.component("bar-chart", chartjs.Bar);
Vue.prototype.$chartjs = chartjs;

import Axios from "axios";
Vue.prototype.$http = Axios;
Axios.defaults.baseURL = process.env.VUE_APP_CTC_API;
Vue.prototype.$APIURL = process.env.VUE_APP_CTC_API;
Vue.prototype.$CCURL = process.env.VUE_APP_CarbonCalculatorUrl;
Vue.prototype.$USERURL = process.env.VUE_APP_UserUrl;
Vue.prototype.$ENV = process.env.VUE_APP_ENV;


const token = localStorage.getItem("CTC_AUTH_TOKEN");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
}

import maths from '@/services/math';
Vue.use(maths);

import PayPal from '@/services/v-paypal';
Vue.use(PayPal, {
  clientId: process.env.VUE_APP_PAYPAL_CLIENTID + "&disable-funding=credit&vault=true",
  env: process.env.NODE_ENV == "production" ? "production" : "sandbox"
});

import ctcQuestion from '@/services/autoQuestion.vue';
Vue.component("question", ctcQuestion);

import refresh from '@/services/refresh.ts';
Vue.use(refresh);

import vTimeout from '@/services/v-timeout.js';
Vue.use(vTimeout, {
  defaultRedirect: '/dashboard/country',
  defaultTimeout: 5 * 60 * 1000 //5 minutes
});

import IdleVue from 'idle-vue';
Vue.use(IdleVue, {
  idleTime: 30 * 60 * 1000, //40 minutes
  store: store
});

import '@/services/raygun.ts';

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_CTC_GOOGLE_KEY }
}, router);

import crossDomainLogin from "@/services/crossDomainLogin.ts";
Vue.use(crossDomainLogin);

new Vue({
  //data() {
  //  return {
  //    userSet: false
  //  }
  //},
  router,
  store,
  created() {
    Axios.interceptors.request.use(
      config => {
        const token = localStorage.getItem("CTC_AUTH_TOKEN");
        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
      },
      err => {
        Promise.reject(err);
      });

    var refreshPromises = [];
    var refreshing = false;
    Axios.interceptors.response.use(resp => {
      return resp;
    }, async (err) => {
      if (err.response.status === 401) {
        if (err.response.headers["token-expired"] == "true" && !refreshing) {
          refreshing = true;
          return new Promise((resolve, reject) => {
            if (store.getters.isFreeUser) {
              var p1 =
                Axios.post("api/freeUser/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") }).then(async (resp) => {
                  store.dispatch("refresh", resp.data);
                  refreshing = false;

                  resolve(Axios.request(err.config));

                }).catch(e => {
                  store.dispatch("logout");
                  router.push({ name: "login" });
                  reject(e);
                });
              refreshPromises.push(p1);
            } else {
              var p1 =
                Axios.post("api/user/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") }).then(async (resp) => {
                  store.dispatch("refresh", resp.data);
                  refreshing = false;

                  resolve(Axios.request(err.config));

                }).catch(e => {
                  store.dispatch("logout");
                  router.push({ name: "login" });
                  reject(e);
                });
              refreshPromises.push(p1);
            }
          })
        }
        else {
          return Promise.all(refreshPromises).then(r => {
            refreshing = false;
            return Axios.request(err.config);
          });
        }
        //else {
        //    store.dispatch('logout');
        //    router.push({ name: "login" });
        //}
        return err.response;
      }
      return Promise.reject(err);
    });
  },
  //computed: {
  //  raygunUser() {

  //    var user = JSON.parse(localStorage.getItem("CTC_USER"));

  //    if (user != null && user.Name != null) {

  //    }
  //    else if (user != null) {

  //    }
  //  }
  //},
  render: h => h(App),
}).$mount('#app');
